import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { commonModules } from 'src/app/app.config';
import { Location, LocationService } from 'src/app/planvue-api';
import { BaseComponent } from '../../base-classes/base-component';
import { UploadComponent, UploadType } from '../../upload/upload.component';

export interface LocationDialogConfig {
  location: Location
}

@Component({
  selector: 'app-location-template-upload-dialog',
  standalone: true,
  imports: [...commonModules, UploadComponent],
  templateUrl: './location-template-upload-dialog.component.html',
  styleUrl: './location-template-upload-dialog.component.scss'
})
export class LocationTemplateUploadDialogComponent extends BaseComponent {
  private readonly locationService: LocationService = inject(LocationService);

  public location!: Location;

  readonly uploadFileType: UploadType = UploadType.ZIP;
  
  constructor(public dialog: MatDialogRef<LocationTemplateUploadDialogComponent>,  @Inject(MAT_DIALOG_DATA) public config: LocationDialogConfig) {
    super();
    this.location = config.location;
  }

  onFileSelected(file: File): void {
    this.locationService.addTemplate(this.location.id!,
      { upload: file }
    ).subscribe(() => {
      this.notifySuccess('Template uploaded successfully');
      this.dialog.close(true);
    });
  }

  onDismiss(): void {
    this.dialog.close(false);
  }

}
